import { createFileRoute, redirect } from '@tanstack/react-router';
import { getActiveBrandId } from '../lib/active-brand.js';
import { brandsQuery, meQuery } from '../lib/queries.js';

// Bookmark-compat redirector. The brief now lives at
// /brand/<slug>/brief — resolve the founder's last-active brand (or
// the org's default) and bounce them there.

export const Route = createFileRoute('/brief')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(meQuery());
    if (!me) throw redirect({ to: '/login' });
    const brands = await queryClient.ensureQueryData(brandsQuery());
    const live = brands.filter((b) => b.archivedAt === null);
    const activeId = getActiveBrandId();
    const target = live.find((b) => b.id === activeId) ?? live[0];
    if (!target) throw redirect({ to: '/brands' });
    throw redirect({ to: '/brand/$slug/brief', params: { slug: target.slug } });
  },
  component: () => null,
});
